/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/** @jsx jsx */
import { jsx, Styled } from 'theme-ui';
import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import htmlParser from 'react-markdown/plugins/html-parser';
import HtmlToReact from 'html-to-react';

const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);

const parseHtml = htmlParser({
  isValidNode: (node) => node.type !== 'script',
  processingInstructions: [
    {
      shouldProcessNode: (node) => node.type === 'tag' && node.name === 'h1',
      processNode: (node, children, index) => (
        <Styled.h1 key={index}>{children}</Styled.h1>
      ),
    },
    {
      shouldProcessNode: (node) => node.type === 'tag' && node.name === 'h2',
      processNode: (node, children, index) => (
        <Styled.h2 key={index}>{children}</Styled.h2>
      ),
    },
    {
      shouldProcessNode: (node) => node.type === 'tag' && node.name === 'p',
      processNode: (node, children, index) => (
        <Styled.p key={index}>{children}</Styled.p>
      ),
    },
    {
      shouldProcessNode: () => true,
      processNode: processNodeDefinitions.processDefaultNode,
    },
  ],
});

const renderers = {
  paragraph: ({ children }) => <Styled.p>{children}</Styled.p>,
  heading: ({ level, children }) => {
    const StyledHeader = Styled[`h${level}`];
    return <StyledHeader>{children}</StyledHeader>;
  },
};

const MarkdownRender = ({ source }) => (
  <ReactMarkdown
    source={source}
    escapeHtml={false}
    astPlugins={[parseHtml]}
    renderers={renderers}
  />
);

MarkdownRender.propTypes = {
  source: PropTypes.string.isRequired,
};

export default MarkdownRender;
